import { Placeholder } from 'rsuite';

const AdvertisersListLoader = () => (
	<>
		{
			new Array(50).fill(0).map((_, i) => (
				<div
					key={i}
					className="flex whitespace-nowrap font-bold text-black border-b border-b-200 h-[82px] items-center"
				>
					<div className="px-[8px] flex-1 flex items-center gap-[16px]">
						<Placeholder.Graph
							active
							className="!w-[40px] !h-[40px] !rounded-full min-w-[40px]"
						/>

						<Placeholder.Graph
							active
							className="!h-[18px]"
						/>
					</div>
					<div className="px-[8px] w-[150px]">
						<Placeholder.Graph
							active
							className="!h-[18px]"
						/>
					</div>
					<div className="px-[8px] w-[200px]">
						<Placeholder.Graph
							active
							className="!h-[18px]"
						/>
					</div>
					<div className="px-[8px] w-[170px]">
						<Placeholder.Graph
							active
							className="!h-[32px] !w-[32px] !min-w-[32px] !rounded-full"
						/>
						<Placeholder.Graph
							active
							className="!h-[32px] !w-[32px] !min-w-[32px] !rounded-full ml-[-10px]"
						/>
						<Placeholder.Graph
							active
							className="!h-[32px] !w-[32px] !min-w-[32px] !rounded-full ml-[-10px]"
						/>
						<Placeholder.Graph
							active
							className="!h-[32px] !w-[32px] !min-w-[32px] !rounded-full ml-[-10px]"
						/>
						<Placeholder.Graph
							active
							className="!h-[32px] !w-[32px] !min-w-[32px] !rounded-full ml-[-10px]"
						/>
						<Placeholder.Graph
							active
							className="!h-[32px] !w-[32px] !min-w-[32px] !rounded-full ml-[-10px]"
						/>
					</div>
					<div className="px-[8px] w-[120px]">
						<Placeholder.Graph
							active
							className="!h-[18px] !w-[24px]"
						/>
					</div>
					<div className="px-[8px] w-[90px]">
						<Placeholder.Graph
							active
							className="!h-[18px]"
						/>
					</div>
					<div className="w-[70px] flex items-center justify-center">
						<Placeholder.Graph
							active
							className="!h-[16px] !w-[16px]"
						/>
					</div>
				</div>
			))
		}
	</>
);

export default AdvertisersListLoader;
